class ApplicationVerificationStatus {
    static init($context = null) {
        var selector = "[data-app-verification-status]";
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            if ($(element).data('app_verification_instance')) return;
            $(element).data('app_verification_instance', new ApplicationVerificationStatus(element))
        });
    }

    loadTimeout = null

    constructor(element) {
        this.version = '0.0.1'
        this.element = element;
        this.$element = $(element);
        this.loadLoadVerificationState();


    }
    basePath() {
        if ($('base').length) {
            return '';
        } else {
            return '/'
        }
    }

    loadLoadVerificationState(){
        clearTimeout(this.loadTimeout)
        this.loadTimeout = setTimeout(() => {
            this.$element.html('<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>')


            $.ajax(`${this.basePath()}api/applications/application_verification_state`, {
                data: {
                    application: this.$element.data('app-verification-status'),
                }
            }).done(function (r) {
                if(r.badge){
                    this.$element.html(r.badge);
                }else{
                    this.$element.html('')
                }
            }.bind(this))
        }, 1000);
    }
}


if (typeof module === "object" && typeof module.exports === "object"){
    ApplicationVerificationStatus.init()
    //node modules support
    module.exports = ApplicationVerificationStatus;
}else{
    $(function(){
        ApplicationVerificationStatus.init()
    });
}